export default __webpack_public_path__ + "static/media/Estrellas.bd2de7e5.png";